import { ActivatedRoute, ActivatedRouteSnapshot } from "@angular/router";

export default class UrlWithoutParamsHelper {

  /**
   * Función que devuelve la ruta compreta sin parametros
   * @param route Objeto de tipo ActivatedRouteSnapshot o ActivatedRoute
   * @returns Devuelve un string con la ruta
   */
  public static getFullUrlWithoutParams(route: ActivatedRouteSnapshot | ActivatedRoute): string{

    // Obtiene la url padre
    const parentUrl = this.getUrlFromParentRoute(route.parent);
    // Obtiene la url de los hijos sin parametros
    const childUrl = this.getUrlFromRoute(route);

    // Concatena la url padre con la hija
    const url = parentUrl + (childUrl == "" ? "" : "/" + childUrl);

    return url;
  }

  /**
   * Función que devuelve la ruta padre
   * @param route Objeto de tipo ActivatedRouteSnapshot o ActivatedRoute
   * @returns Devuelve un string con la ruta
   */
  private static getUrlFromParentRoute(route: ActivatedRouteSnapshot | ActivatedRoute): string {

    // Valida que la ruta no este vacia
    if (!route || (route && !route.routeConfig) || (route && route.routeConfig.path.startsWith(":") || route.routeConfig.path.startsWith("*"))){
      return route.parent ? this.getUrlFromParentRoute(route.parent) : "";
    }

    // Obtiene la url padre
    let parentUrl = this.getUrlFromParentRoute(route.parent);

    // Limpia los segmentos :param o *wildcard dentro del path (ej: "view/:id" → "view")
    const cleanPath = this._stripParamSegments(route.routeConfig.path);

    // Devuelve la ruta
    return (parentUrl == "" || cleanPath == "" ? parentUrl : parentUrl + "/") + cleanPath;

  }

  /**
   * Función que devuelve la ruta sin los parametros
   * @param route Objeto de tipo ActivatedRouteSnapshot o ActivatedRoute
   * @returns Devuelve un string con la ruta
   */
  private static getUrlFromRoute(route: ActivatedRouteSnapshot | ActivatedRoute): string{

    // Valida que la ruta no sea nula o que el path no sea un parametro
    if (!route || (route && route.routeConfig.path.startsWith(":") || route.routeConfig.path.startsWith("*"))){
      return "";
    }

    // Limpia los segmentos :param o *wildcard dentro del path (ej: "view/:id" → "view")
    const cleanPath = this._stripParamSegments(route.routeConfig.path);

    // Obtiene la url del hijo
    let childrenUrl = this.getUrlFromRoute(route.firstChild);

    // Devuelve la ruta
    return cleanPath + (childrenUrl == "" ? childrenUrl : "/" + childrenUrl);

  }

  /**
   * Elimina los segmentos que son parámetros (:id) o wildcards (*) dentro de un path.
   * Ejemplo: "view/:id" → "view", ":id" → "", "section/:a/:b/detail" → "section/detail".
   */
  private static _stripParamSegments(path: string): string {
    if (!path) return "";
    return path
      .split("/")
      .filter(segment => segment && !segment.startsWith(":") && !segment.startsWith("*"))
      .join("/");
  }

}
